/* eslint-disable @typescript-eslint/no-explicit-any */
import Cookies from 'universal-cookie'
import { LOGIN_TOKEN_KEY } from '../config'

export const getToken = (req?: { headers: { cookie: any } }): string => {
  const cookies = req ? new Cookies(req.headers.cookie) : new Cookies()
  const token: string = cookies.get(LOGIN_TOKEN_KEY) || ''
  return token
}
